/**
 * Create a hash where domains are the key and locales are the values, i.e:
 *
 * {
 *  'de.trovit.com': {
 *    countryCode: 'de',
 *    locale: 'de-DE',
 *    target: 'trovit',
 *    paths: {
 *      '/immobilien': 'homes',
 *      '/autos': 'cars',
 *      '/jobs': 'jobs'
 *    }
 *  },
 *  'autos.trovit.com.pa': {
 *    countryCode: 'pa',
 *    locale: 'es-PA',
 *    target: 'cars'
 *  },
 *  'casas.trovit.com.pa': {
 *    countryCode: 'pa',
 *    locale: 'es-PA',
 *    target: 'homes'
 *  }
 * }
 */
const transformDomainsToHashByDomain = (testingPrefix, suffix, domains) => {
  const hash = {};

  Object.keys(domains).forEach(countryKey => {
    const country = domains[countryKey];
    const locale = country.locale;

    Object.keys(domains[countryKey].verticals).forEach(verticalKey => {
      const vertical = country.verticals[verticalKey];
      const domain = `${testingPrefix}${vertical.domain}${suffix}`;
      const target = vertical.target;
      const path = vertical.path;

      if (!hash[domain]) {
        hash[domain] = { countryCode: countryKey, locale, target, paths: {} };
      } else {
        hash[domain].paths[path] = verticalKey;
      }
    });
  });

  return hash;
};

module.exports = transformDomainsToHashByDomain;



// WEBPACK FOOTER //
// ./server/config/domains-reader.js